import { React, useEffect, useState } from 'react'
import axios from 'axios'
import {Table, Checkbox, Button } from 'flowbite-react'
import LoadingSpinner from '../../components/LoadingSpinner';


const RolesList = ({onClose,userId,users, setUsers}) => {
    const [Roles, setRoles] = useState([]);
    //const [Users, setRoles] = useState(users);
    const [Error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isChangeStatus, setChangeStatus] = useState(false);


    const handleChange = async (id,checked) => {
        setIsLoading(true);

        
        setRoles((prevRoles) =>
            prevRoles.map((rol) =>
                rol.id === id
            ? { ...rol, checked: !rol.checked } 
            : rol
            )
        );
        console.log(`id:${id} checked: ${!checked}`);
        try {
            const response = await axios.post( 
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/userrole/${userId}/findorcreate`,
                {
                    roleId: id
                },
                {
                    withCredentials: true,
                }
            );
        } catch (error) {
            setError(error.message);
        } finally{
            setIsLoading(false);
            setChangeStatus(true);
            //setUsers(users);
        } 
        
        
    };

    useEffect(()=>{
        const getRolesByUser = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get( 
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/userrole/${userId}`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }

                setRoles(response.data.roles);
            } catch (error) {
                setError(error.message);
            } finally{
                setIsLoading(false);
            } 
        }
        getRolesByUser();

        console.log("status",isChangeStatus);
        if(isChangeStatus){
            console.log("actualizaRoles");
        }
    },[isChangeStatus]);

  return (
    <>
        {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
        <div className="overflow-x-auto">
        <Table hoverable>
            <Table.Head>
            <Table.HeadCell className="p-4">
                <Checkbox />
            </Table.HeadCell>
            <Table.HeadCell>Rol</Table.HeadCell>
            <Table.HeadCell>Descripción</Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
                {Roles.map((rol) => (
                    <Table.Row key={rol.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                        <Table.Cell className="p-4">
                        <Checkbox 
                            key={rol.id}
                            name="checkRol"
                            className="rolesCheck"
                            onChange={()=>handleChange(rol.id, rol.checked)} 
                            checked={rol.checked}
                            />
                        </Table.Cell>
                        <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                            {rol.name}
                        </Table.Cell>
                        <Table.Cell>{rol.description}</Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
        </div>
    </>
  )
}

export default RolesList
    